import { transformRoutes } from '@backoffice-frontend/common'

export const BaseRiderFeedbackAreaRoutes = {
  route: '/rider-feedback',
  Overview: {
    route: '/overview',
  },
}

export const RiderFeedbackAreaRoutes = transformRoutes(
  BaseRiderFeedbackAreaRoutes,
)
